/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Automatic_TranscriptionInputs */

const en_automatic_transcription = /** @type {(inputs: Automatic_TranscriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Automatic Transcription`)
};

const fr_automatic_transcription = /** @type {(inputs: Automatic_TranscriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Transcription automatique`)
};

const de_automatic_transcription = /** @type {(inputs: Automatic_TranscriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Automatische Transkription`)
};

const it_automatic_transcription = /** @type {(inputs: Automatic_TranscriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Trascrizione automatica`)
};

const ru_automatic_transcription = /** @type {(inputs: Automatic_TranscriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Автоматическая транскрипция`)
};

const es_automatic_transcription = /** @type {(inputs: Automatic_TranscriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Transcripción automática`)
};

const zh_cn2_automatic_transcription = /** @type {(inputs: Automatic_TranscriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`自动转录`)
};

const ja_automatic_transcription = /** @type {(inputs: Automatic_TranscriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`自動転写`)
};

const hi_automatic_transcription = /** @type {(inputs: Automatic_TranscriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`स्वचालित प्रतिलेखन`)
};

const pt_pt2_automatic_transcription = /** @type {(inputs: Automatic_TranscriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Transcrição automática`)
};

/**
* | output |
* | --- |
* | "Automatic Transcription" |
*
* @param {Automatic_TranscriptionInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const automatic_transcription = /** @type {((inputs?: Automatic_TranscriptionInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Automatic_TranscriptionInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_automatic_transcription(inputs)
	if (locale === "de") return de_automatic_transcription(inputs)
	if (locale === "it") return it_automatic_transcription(inputs)
	if (locale === "ru") return ru_automatic_transcription(inputs)
	if (locale === "es") return es_automatic_transcription(inputs)
	if (locale === "zh-CN") return zh_cn2_automatic_transcription(inputs)
	if (locale === "ja") return ja_automatic_transcription(inputs)
	if (locale === "hi") return hi_automatic_transcription(inputs)
	if (locale === "pt-PT") return pt_pt2_automatic_transcription(inputs)
	return en_automatic_transcription(inputs)
});